import * as React from 'react';
import { cn } from '@/lib/utils';

// Native <textarea> with shadcn styling. Defaults to 2 rows; pass `rows={n}`
// or override `min-h` via className. Auto-grows is not built in — let
// content overflow or set `resize-y` explicitly when needed.
const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.TextareaHTMLAttributes<HTMLTextAreaElement>
>(({ className, ...props }, ref) => (
  <textarea
    ref={ref}
    className={cn(
      'flex w-full rounded-lg border border-input bg-background/60 px-3 py-2 text-sm',
      'placeholder:text-muted-foreground',
      'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1 focus-visible:ring-offset-background',
      'disabled:cursor-not-allowed disabled:opacity-50',
      'min-h-[60px] resize-y',
      className,
    )}
    {...props}
  />
));
Textarea.displayName = 'Textarea';

export { Textarea };
